export default __webpack_public_path__ + "static/media/bubble2.91d94819.png";